import { openAPIClient } from '../openApiClient';
import type {
  BatchArchiveMediaGalleryServiceConfig,
  CreateMediaGalleryServiceConfig,
  GetMediaGalleryItemServiceConfig,
  MediaGalleryCreateResponse,
  MediaGalleryGetResponse,
  MediaGalleryListResponse,
  MediaGalleryListServiceConfig,
} from './types/index';

export async function getMediaGalleryListService({
  httpRequestConfig,
  params,
}: MediaGalleryListServiceConfig): Promise<MediaGalleryListResponse> {
  const client = await openAPIClient(httpRequestConfig);

  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.GET('/v1/auth/mediaGallery/{spaceId}', {
    params: {
      path: {
        spaceId: httpRequestConfig.space,
      },
      query: params.query,
    },
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}

/**
 * Service function to get a single media gallery item by ID
 * Uses the GET /v1/auth/mediaGallery/{spaceId}/{id} endpoint
 */
export async function getMediaGalleryItemService({
  httpRequestConfig,
  params,
}: GetMediaGalleryItemServiceConfig): Promise<MediaGalleryGetResponse> {
  const client = await openAPIClient(httpRequestConfig);

  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.GET('/v1/auth/mediaGallery/{spaceId}/{id}', {
    params: {
      path: {
        spaceId: httpRequestConfig.space,
        id: params.params.id,
      },
    },
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}

export async function createMediaGalleryItemService({
  httpRequestConfig,
  params,
}: CreateMediaGalleryServiceConfig): Promise<MediaGalleryCreateResponse> {
  const client = await openAPIClient(httpRequestConfig);

  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.POST('/v1/auth/mediaGallery/{spaceId}', {
    params: {
      path: {
        spaceId: httpRequestConfig.space,
      },
    },
    body: params.body,
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}

/**
 * Service function to archive multiple media gallery items in batch mode
 * Uses the batch archive endpoint from the API
 */
export async function batchArchiveMediaGalleryItemsService({
  httpRequestConfig,
  params,
}: BatchArchiveMediaGalleryServiceConfig): Promise<void> {
  const client = await openAPIClient(httpRequestConfig);

  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.POST('/v1/auth/mediaGallery/{spaceId}/batchArchive', {
    params: {
      path: {
        spaceId: httpRequestConfig.space,
      },
    },
    body: params.body,
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }
}
